module.exports = require("paths-js/path");